import { OnInit, Component, Input } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AdministrarFuncionarioDTO } from 'src/app/models/administrarFuncionario.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
    selector: 'app-informacion-vinculacion-component',
    templateUrl: './informacion-vinculacion.component.html',
    styleUrls: ['./../administrar-funcionarios.component.scss']
})
export class InformacionVinculacionComponent implements OnInit {

    @Input() datos: AdministrarFuncionarioDTO;
    @Input() existeFuncionario: boolean;
    @Input() dominios: DetalleDominio[];

    public deshabilitado: boolean;
    public isTecnologia: boolean;
    public rolUsuario: string;
    public vinculacionAnterior: string;
    public consultaVinculaciones: any;
    public vinculaciones: any;
    public consultaEstados: any;
    opcSelect: string;

    constructor(
        private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private global: GlobalService,
        private alertService: AlertService) {
        this.consultaVinculaciones = [];
        this.consultaEstados = [];
    }

    ngOnInit() {
        this.opcSelect=sessionStorage.getItem(ConstantesService.OPC_SELECT);
        this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);
        this.obtenerVinculaciones();
        this.obtenerEstados();
        this.habilitarEdicion();
        
        if (this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_SGA && !this.datos.tipoVinculacion) {
            if( this.opcSelect === VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL_TERCE){
                this.datos.tipoVinculacion = DominiosService.TIPO_VINCULACION_TERCERO;
            }else
                this.datos.tipoVinculacion = DominiosService.TIPO_VINCULACION_CONTRATISTA;
        }

        this.isTecnologia = this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TEC;
        this.actualizarTipoVinculacion(this.datos.tipoVinculacion);

    }

    habilitarEdicion() {
                 this.deshabilitado = this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TEC
                    || (this.existeFuncionario &&
                        ((this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TH
                            && this.datos.tipoVinculacion == DominiosService.TIPO_VINCULACION_CONTRATISTA)
                            || (this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_SGA
                                && this.datos.tipoVinculacion != DominiosService.TIPO_VINCULACION_CONTRATISTA)
                                && this.datos.tipoVinculacion != DominiosService.TIPO_VINCULACION_TERCERO))
                                
                                || (this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TH 
                                    && this.datos.tipoVinculacion == DominiosService.TIPO_VINCULACION_TERCERO  );
    }

    /**
     * Consulta los tipo de Vinculación Existente
     */
    public obtenerVinculaciones() {
        this.vinculaciones = this.dominios.filter(dominio =>
            dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_TIPO_VINCULACION);
        this.actualizarListaVinculaciones(this.vinculaciones);
        this.habilitarCambioTipo();
    }

    actualizarListaVinculaciones(data) {

        if (this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_SGA && !this.existeFuncionario) {
           
            if(this.opcSelect === VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL_TERCE){
                this.consultaVinculaciones = data.filter(detalle =>
                    detalle.detalleDominioPK.nombreDetalleDominio === DominiosService.TIPO_VINCULACION_TERCERO);
            }else{
                this.consultaVinculaciones = data.filter(detalle =>
                    detalle.detalleDominioPK.nombreDetalleDominio === DominiosService.TIPO_VINCULACION_CONTRATISTA);
            }

        } else {
            console.log("Rol::"+this.rolUsuario)
            if( this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH ){
                    
                    this.consultaVinculaciones = data.filter(detalle =>
                        detalle.detalleDominioPK.nombreDetalleDominio !== DominiosService.TIPO_VINCULACION_TERCERO
                        && detalle.detalleDominioPK.nombreDetalleDominio !== DominiosService.TIPO_VINCULACION_CONTRATISTA);

            }else{
                this.consultaVinculaciones = data;
            }
        }
    }

    /**
     * Consulta los tipo de estado Existente
     */
    public obtenerEstados() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'EstadoFuncionario']);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.consultaEstados = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener los Estados');
            }
        );
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

    actualizarTipoVinculacion(valor) {
        if (this.existeFuncionario && !this.vinculacionAnterior) {
            this.vinculacionAnterior = valor;
        }
    }

    habilitarCambioTipo() {
        if (this.existeFuncionario && this.datos.estado === 'INA') {
            this.deshabilitado = false;
            this.consultaVinculaciones = this.vinculaciones;
        } else if (this.existeFuncionario) {
            this.habilitarEdicion();
            if (this.vinculacionAnterior) {
                this.datos.tipoVinculacion = String(this.vinculacionAnterior);
            }
            this.reiniciarVinculaciones();
        }
    }

    reiniciarVinculaciones() {
        if ((this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH
            && this.datos.tipoVinculacion === DominiosService.TIPO_VINCULACION_CONTRATISTA)
            || (this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_SGA
                && this.datos.tipoVinculacion !== DominiosService.TIPO_VINCULACION_CONTRATISTA)) {

            this.consultaVinculaciones = this.vinculaciones;
        
        } else if (this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH) {
            
            this.consultaVinculaciones = this.vinculaciones.filter(detalle =>
                detalle.detalleDominioPK.nombreDetalleDominio !== DominiosService.TIPO_VINCULACION_CONTRATISTA);
        
        } else if (this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_SGA) {
           
            this.consultaVinculaciones = this.vinculaciones.filter(detalle =>
                detalle.detalleDominioPK.nombreDetalleDominio === DominiosService.TIPO_VINCULACION_CONTRATISTA);
        
            }
    }
}
